import React from "react";

import "./bookATour.css";

import firstImage from "../../assets/home/bookATour.jpg";

const BookATour = () => (
  <div className="container-fluid book-tour-wrapper">
    <div className="row">
      <div className="col-md-6">
        <div
          className="book-tour-bg-image"
          style={{ background: `url("${firstImage}")` }}
        ></div>
      </div>
      <div className="col-md-6">
        <div className="book-tour-content-wrapper">
          <div>
            <h2 className="text-jumbo">
              Our Mission is to
              <br />
              develop and nurture students
              <br />
              into their fullest spiritual,
              <br />
              academic, physical and social self
            </h2>
            
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BookATour;
